import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import Api from '../../../util/api';
import { formatCurrencyNumber } from '../../../util/functions';
import Pagination from '../../../shared/components/pagination/Pagination';
import t, { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import { formatDateTime } from '../../../util/date-and-time';
import useModal from '../../../shared/hooks/useModal';
import DeleteModal from '../../../shared/components/custom/DeleteModal';

const AutoBidsList = ({ auctionItemId, setLoading }) => {
  const p = partial('auctionObjectsShared');
  const s = partial('shared');
  const config = useConfig();
  const [autoBids, setAutoBids] = useState([]);
  const [handleModal, visible, deleteObject] = useModal();

  const [pagination, setPagination] = useState({
    total: 0,
    currentPage: 1,
    perPage: 10,
  });

  const fetchAutoBids = async (currentPage = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const resAutoBids = await Api.auctions.getAuctionItemAutoBids(
        auctionItemId,
        { page: currentPage, take: pageSize }
      );
      const userIds = [
        ...new Set(
          resAutoBids.data
            .map((item) => item.userId)
            .filter((userId) => userId !== null)
        ),
      ];
      const { data: usersByIds } = await Api.users.getUsersByCloudIds(userIds);
      const userByIdMap = {};
      for (let i = 0; i < usersByIds.length; i++) {
        userByIdMap[usersByIds[i].userCloudId] = usersByIds[i];
      }
      const mappedAutoBids = resAutoBids.data.map((autoBid) => ({
        ...autoBid,
        user: userByIdMap[autoBid.userId],
      }));
      setAutoBids(mappedAutoBids);
      setPagination((old) => ({ ...old, total: resAutoBids.count }));
      setLoading(false);
    } catch (err) {
      toast.error(p('autoBidsRetrievingERROR'));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (auctionItemId) {
      fetchAutoBids();
    }
  }, [auctionItemId]);

  const onChangePage = (pager) => {
    if (
      pager.pageSize !== pagination.perPage ||
      pager.currentPage !== pagination.currentPage
    ) {
      setPagination((old) => ({
        ...old,
        currentPage: pager.currentPage,
        perPage: pager.pageSize,
      }));
      fetchAutoBids(pager.currentPage, pager.pageSize);
    }
  };

  const renderAutoBids = () => {
    return autoBids.map((autoBid, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`autoBid-${autoBid.id}`}
      >
        <td>
          <div className="flex-Vcenter">
            <div>
              <Link
                to={`/users/edit/${autoBid.userId}`}
              >{`${autoBid.user?.firstname} ${autoBid.user?.lastname}`}</Link>
              <br />
              <span
                style={{ fontSize: 10 }}
              >{`${autoBid.user?.phoneNumber}`}</span>
              <br />
              <span style={{ fontSize: 10 }}>{`${autoBid.user?.email}`}</span>
            </div>
          </div>
        </td>
        <td>
          <b>
            {formatCurrencyNumber(Number(autoBid.maxAmount))}{' '}
            {config.currencyCaps}
          </b>
        </td>

        <td>{formatDateTime(autoBid.createdAt)}</td>
        <td>
          <UncontrolledDropdown className="dashboard__table-more">
            <DropdownToggle>
              <DotsHorizontalIcon />
            </DropdownToggle>
            <DropdownMenu className="dropdown__menu">
              <DropdownItem
                onClick={() =>
                  handleModal({
                    id: autoBid.id,
                    type: 'autoBid',
                  })
                }
                className="danger"
              >
                {s('delete')}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));
  };

  const deleteAutoBid = async () => {
    try {
      await Api.auctions.deleteAutoBid(deleteObject.id);
      handleModal();
      fetchAutoBids();
    } catch (err) {
      toast.error(p('autoBidsRetrievingERROR'));
    }
  };
  return (
    <>
      <DeleteModal
        visible={visible}
        modalType={'delete'}
        type={p('autoBid').toLowerCase()}
        handleModal={handleModal}
        modalAction={deleteAutoBid}
      />

      <div
        style={{
          display: 'flex',
          paddingBottom: 5,
          marginTop: 10,
          background: '#fff',
          borderRadius: 6,
          boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
        }}
      >
        <Table responsive striped>
          <thead>
            <tr>
              <th style={{ color: '#4D576A' }} className="sortable">
                <div className="flex alignItems-center">{s('user')}</div>
              </th>
              <th style={{ color: '#4D576A' }}>
                <div className="flex alignItems-center">{p('maxAmount')}</div>
              </th>
              <th style={{ color: '#4D576A' }}>
                <div className="flex alignItems-center">{s('date')}</div>
              </th>
              <th />
            </tr>
          </thead>
          <tbody>{renderAutoBids()}</tbody>
        </Table>
      </div>
      <Pagination
        items={pagination.total}
        onChangePage={onChangePage}
        initialPage={pagination.currentPage}
      />
    </>
  );
};

export default AutoBidsList;
